import AssignmentIcon from '@mui/icons-material/Assignment';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useToast, { TOAST_TYPE } from '../../../hooks/useToast';

const CopyCollectionUrlButton = ({ domain, name }) => {
  const { t } = useTranslation();
  const { showToast } = useToast();

  const handleCopy = () => {
    const collectionUrl = `${domain}/${name}/`;
    navigator.clipboard.writeText(collectionUrl);
    showToast(
      TOAST_TYPE.INFO,
      t('copiedCollectionUrl', { ns: 'notifications' })
    );
  };

  return (
    <Tooltip title={t('copyCollectionUrl', { ns: 'instance' })} arrow={true}>
      <IconButton onClick={handleCopy} aria-label="copy text" size="large">
        <AssignmentIcon />
      </IconButton>
    </Tooltip>
  );
};

CopyCollectionUrlButton.propTypes = {
  name: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
};

export default CopyCollectionUrlButton;
